import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faArrowUpFromBracket, faChevronLeft, faChevronRight, faMagnifyingGlass, faPlus, faXmark, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import "./jobboard.css"
import { apiService } from '../../services/apiService';
import { Slider } from '@mui/material';

const SESSION_KEY = "jobBoardAdminState";

const saveStateToSession = (state) => {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
  } catch (err) {
    console.error("Failed to save state to sessionStorage:", err);
  }
};

const loadStateFromSession = () => {
  try {
    const data = sessionStorage.getItem(SESSION_KEY);
    return data ? JSON.parse(data) : {};
  } catch (err) {
    console.error("Failed to load state from sessionStorage:", err);
    return {};
  }
};

function JobBoard() {
    const navigate = useNavigate();
    const closeElement = () => {
        setIsVisible(true);
    };
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const sessionState = loadStateFromSession();

    const isInitialRender = useRef(true);
    const hasRestoredData = useRef(!!sessionState?.jobslist?.length);

    const [typedata, setTypeData] = useState(() => sessionState.typedata || "all_jobs");
    const [isVisible, setIsVisible] = useState(() => sessionState.isVisible ?? true);
    const [jobslist, setJobs] = useState(() => sessionState.jobslist || []);
    const [paginatedata, setPaginateData] = useState(() => sessionState.paginatedata || {});
    const [currentPage, setCurrentPage] = useState(() => sessionState.currentPage || 1);
    const [searchQuery, setSearchQuery] = useState(() => sessionState.searchQuery || "");
    const [innerSearch, setInnersearch] = useState(() => sessionState.innerSearch || "");
    const [locationQuery, setLocationQuery] = useState(() => sessionState.locationQuery || "");
    const [locationSearch, setLocationSearch] = useState(() => sessionState.locationSearch || "");
    const [shorting, setShorting] = useState(() => sessionState.shorting || "");
    const [loading, setLoading] = useState(() => !sessionState?.jobslist?.length);

    const [selectedPostedDates, setSelectedPostedDates] = useState(() => sessionState.selectedPostedDates || []);
    const [selectedRoleTypes, setSelectedRoleTypes] = useState(() => sessionState.selectedRoleTypes || []);
    const [selectedSalaryTypes, setSelectedSalaryTypes] = useState(() => sessionState.selectedSalaryTypes || "");
    const [selectedPosterTypes, setSelectedPosterTypes] = useState(() => sessionState.selectedPosterTypes || []);
    const [selectedSitesTypes, setSelectedSitesTypes] = useState(() => sessionState.selectedSitesTypes || []);
    const [selectedJobTypes, setSelectedJobTypes] = useState(() => sessionState.selectedJobTypes || []);
    const [selectedSourceTypes, setSelectedSourceTypes] = useState(() => sessionState.selectedSourceTypes || []);
    const [selectedExperience, setSelectedExperience] = useState(() => sessionState.selectedExperience || []);
    const [selectedCityzenship, setSelectedCityzenship] = useState(() => sessionState.selectedCityzenship || []);
    const [salaryRange, setSalaryRange] = useState(() => sessionState.salaryRange || [0, 0]);
    const [showRange, setRangeshow] = useState(sessionState.selectedSalaryTypes === "unknown" ? true : false);


    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const fetchSuggestions = async (query) => {
        if (!query) {
            return;
        }
    
        try {
            const response = await apiService.postRequest("locations/suggestions", { "search": query });
            if(response && response.success){
            setFilteredSuggestions(response.data || [])
            //   setSuggestions(response.tags || []); // Adjust based on API response
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setLocationQuery(value);
        if (value) {
            fetchSuggestions(value);
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setLocationQuery(suggestion);
        setShowSuggestions(false);
    };
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown" && activeIndex < filteredSuggestions.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (e.key === "ArrowUp" && activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        } else if (e.key === "Enter") {
            if (activeIndex >= 0) {
                const selected = filteredSuggestions[activeIndex];
                setLocationQuery(selected.label);
                // setLocationQuery(e.target.value)
                setShowSuggestions(false);
            }
            handleSearchLocation();
        }
    };

    const handleCheckboxChange = (event, setState) => {
        const { value, checked } = event.target;
        setState((prev) => {
        const newState = checked ? [...prev, value] : prev.filter((item) => item !== value);
        setCurrentPage(1);
        return newState;
        });
    };

    const handleSalaryChange = (event, newValue) => {
        setSalaryRange(newValue);
    };

    const handleSalaryCommitted = () => {
        setCurrentPage(1);
        fetchJobs({ page: 1 });
    };

    const handleSalarytypeChange = (e) => {
        const { value } = e.target;
        setSelectedSalaryTypes(value);
        setCurrentPage(1);
        if(value === "unknown"){
            setRangeshow(true)
            setSalaryRange([0, 0]);
        }else{
            setRangeshow(false);
        }
    };

    const fetchJobs = useCallback(async (params = {}) => {
        setLoading(true);
        try {
        const salaryParams =
            salaryRange[0] === 0 && salaryRange[1] === 0
            ? {}
            : { salary_min: salaryRange[0], salary_max: salaryRange[1] };
            const defaultParams = {
                type: typedata,
                sort: shorting,
                page: currentPage,
                location: locationSearch,
                search: innerSearch,
                posted_date: selectedPostedDates.join(","),
                role_type: selectedRoleTypes.join(","),
                poster_type: selectedPosterTypes.join(","),
                site_type: selectedSitesTypes.join(","),
                job_type: selectedJobTypes.join(","),
                salary_type: selectedSalaryTypes || "",
                source: selectedSourceTypes.join(","),
                experience_range: selectedExperience.join(","),
                citizenship_status: selectedCityzenship.join(","),
                ...salaryParams,
                ...params,
            };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/job-posts?${queryString}`);
            if (response && response.success === true) {
                setJobs(response.data);
                setPaginateData(response.meta);
            } else if (response.authenticate === false) {
                await apiService.postRequest("/auth/logout");
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = "/login";
            }
        } catch (error) {
        console.error("Error fetching tab data:", error);
        } finally {
        setLoading(false);
        }
    }, [
        typedata, shorting, currentPage, innerSearch,
        selectedSalaryTypes, salaryRange, locationSearch,
        selectedPostedDates, selectedRoleTypes, selectedPosterTypes,
        selectedSitesTypes, selectedJobTypes, selectedSourceTypes,
        selectedExperience, selectedCityzenship
    ]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchJobs({ page: newPage });
    };
    const handleSearch = () => {
        setCurrentPage(1);
        setInnersearch(searchQuery);
    };
    const handleSearchLocation = () => {
        setCurrentPage(1);
        setLocationSearch(locationQuery);
    };
    const handleShortType = (newData) => {
        setCurrentPage(1);
        setTypeData(newData);
    };
    const handleShortNew = (newData) => {
        setCurrentPage(1);
        setShorting(newData);
    };

    useEffect(() => {
        if (!hasRestoredData.current) {
            fetchJobs();
        }
        isInitialRender.current = false;
    }, [fetchJobs]);

    useEffect(() => {
        if (isInitialRender.current && hasRestoredData.current) return;
            fetchJobs();
    }, [
        fetchJobs, shorting, innerSearch, selectedSalaryTypes, salaryRange,
        locationSearch, selectedPostedDates, selectedRoleTypes,
        selectedPosterTypes, selectedSitesTypes, selectedJobTypes,
        selectedSourceTypes, selectedExperience, selectedCityzenship
    ]);
    
    useEffect(() => {
        const stateToSave = {
            typedata, isVisible, jobslist, paginatedata, currentPage,
            searchQuery, innerSearch, locationQuery, locationSearch, shorting,
            selectedPostedDates, selectedRoleTypes, selectedSalaryTypes,
            selectedPosterTypes, selectedSitesTypes, selectedJobTypes,
            selectedSourceTypes, selectedExperience, selectedCityzenship, salaryRange
        };
        saveStateToSession(stateToSave);
    }, [
        typedata, isVisible, jobslist, paginatedata, currentPage,
        searchQuery, innerSearch, locationQuery, locationSearch, shorting,
        selectedPostedDates, selectedRoleTypes, selectedSalaryTypes,
        selectedPosterTypes, selectedSitesTypes, selectedJobTypes,
        selectedSourceTypes, selectedExperience, selectedCityzenship, salaryRange
    ]);

    // Modified navigate function to preserve state
    const navigateToJobDetails = (jobId) => {
        navigate(`/job-board/view-job/${jobId}`);
    };


    const clearState = () => {
        sessionStorage.removeItem("jobBoardAdminState");
        window.location.reload();
    };
    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.removeItem("jobBoardAdminState");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
  return (
    <div className='container-fluid px-0'>
        <div className={isVisible === true ? 'hide_mobitr' : 'show_mobitr'}>
            <div className='filter_jobboardmain'>
                <div className='d-flex w-100 justify-content-end'>
                    <button className='d-md-none closecat_btn' onClick={closeElement}><FontAwesomeIcon icon={faXmark} /></button>
                </div>
                <div className='d-flex flex-column filter_mainjob pe-3 mt-3'>
                    <h4>Search Job</h4>
                    <div className='d-flex search_forfiltersjob'>
                        <div className='d-flex w-100 align-items-center' style={{ position: "relative" }}>
                            <div className='col-2 px-0 text-center'>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className='col-8 px-0'>
                                <input type='text' placeholder='Search by City and State'
                                    value={locationQuery}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                    onFocus={() => searchQuery && setShowSuggestions(true)}
                                />
                                {showSuggestions && (
                                    <ul className="suggestions-dropdown">
                                        {filteredSuggestions.length > 0 ? (
                                            filteredSuggestions.map((suggestion, index) => (
                                                <li
                                                    key={index}
                                                    className={index === activeIndex ? "active" : ""}
                                                    onMouseDown={() => handleSuggestionClick(suggestion.label)}
                                                >
                                                    {suggestion.label}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="no-suggestions">No results found</li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            <div className='col-2 px-0 d-flex justify-content-end'>
                                <button onClick={handleSearchLocation}><FontAwesomeIcon icon={faArrowRight} /></button>
                            </div>
                        </div>
                    </div>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob mt-3">
                        <h5>Posted Date Range</h5>
                        {[
                            { label: "24 Hours", value: "24_hours" },
                            { label: "2 Days", value: "2_days" },
                            { label: "This Week", value: "this_week" },
                            { label: "Last Week", value: "last_week" },
                            { label: "Last 30 Days", value: "last_30_days" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedPostedDates.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedPostedDates)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Role Type</h5>
                        {[
                            { label: "Admin", value: "Admin" },
                            { label: "Developer", value: "Developer" },
                            { label: "Business Analyst", value: "Business Analyst" },
                            { label: "Consultant", value: "Consultant" },
                            { label: "Manager", value: "Manager" },
                            { label: "Product Owner", value: "Product Owner" },
                            { label: "Business System Analyst", value: "Business System Analyst" },
                            { label: "Developer/Administrator", value: "Developer/Administrator" },
                            { label: "Others", value: "Others" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedRoleTypes.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedRoleTypes)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Poster Type</h5>
                        {[
                            { label: "Staffing Company", value: "Staffing Company" },
                            { label: "Implementation Partners", value: "Implementation Partners" },
                            { label: "Direct Requirement", value: "Direct Requirement" },
                            { label: "Unknown", value: "Unknown" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedPosterTypes.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedPosterTypes)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Site Type</h5>
                        {[
                            { label: "Remote", value: "Remote" },
                            { label: "Onsite", value: "Onsite" },
                            { label: "Hybrid", value: "Hybrid" },
                            { label: "Unknown", value: "unknown" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedSitesTypes.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedSitesTypes)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Job Type</h5>
                        {[
                            { label: "Full-time", value: "Full-time" },
                            { label: "Part-time", value: "Part-time" },
                            { label: "Contract", value: "Contract" },
                            { label: "Temporary", value: "Temporary" },
                            { label: "Internship", value: "Internship" },
                            { label: "Unknown", value: "unknown" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedJobTypes.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedJobTypes)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <span>Salary Type</span>
                        <select className='joboard_typeselect' value={selectedSalaryTypes} onChange={handleSalarytypeChange}>
                            <option value="">Select Type</option>
                            <option value="hourly">Hourly</option>
                            <option value="yearly">Yearly</option>
                            <option value="unknown">Unknown</option>
                        </select>
                        {!showRange && <>
                        <h5>Salary Range</h5>
                        <h6>${salaryRange[0]} - ${salaryRange[1]}</h6>
                        <div className='px-4 slider_colormain'>
                        <Slider
                            getAriaLabel={() => 'Salary range'}
                            value={salaryRange}
                            onChange={handleSalaryChange}
                            onChangeCommitted={handleSalaryCommitted}
                            valueLabelDisplay="auto"
                            getAriaValueText={(value) => `${value} USD`}
                            min={0} // Minimum salary
                            max={200000} // Maximum salary
                        />
                        </div>
                        <small className='resetprice_rangesmall' onClick={()=> setSalaryRange([0,0])}>Reset Price Range</small>
                        </>}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Source</h5>
                        {[
                            { label: "TekP Intelligence", value: "TekP Intelligence" },
                            { label: "LinkedIn", value: "LinkedIn" },
                            { label: "Monster", value: "Monster" },
                            { label: "Indeed", value: "Indeed" },
                            { label: "Glassdoor", value: "Glassdoor" },
                            { label: "Dice", value: "Dice" },
                            { label: "Techfetch", value: "Techfetch" },
                            { label: "Other", value: "Other" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedSourceTypes.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedSourceTypes)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Experience Level</h5>
                        {[
                            { label: "No experience", value: "No experience" },
                            { label: "0 to 2 years", value: "0 to 2 Years" },
                            { label: "2 to 5 years", value: "2 to 5 Years" },
                            { label: "5 to 8+ years", value: "5 to 8+ Years" },
                            { label: "8 to 12+ years", value: "8 to 12+ Years" },
                            { label: "15+ years", value: "15+ Years" },
                            { label: "Unknown", value: "unknown" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedExperience.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedExperience)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <h5>Citizenship Status</h5>
                        {[
                            { label: "CPT", value: "CPT" },
                            { label: "GC", value: "GC" },
                            { label: "GC EAD", value: "GC EAD" },
                            { label: "H1B", value: "H1B" },
                            { label: "H4 EAD", value: "H4 EAD" },
                            { label: "L2 EAD", value: "L2 EAD" },
                            { label: "OPT EAD", value: "OPT EAD" },
                            { label: "USC", value: "USC" },
                            { label: "Unknown", value: "unknown" },
                        ].map((item) => (
                            <span key={item.value}>
                                <input 
                                    type="checkbox" 
                                    value={item.value} 
                                    checked={selectedCityzenship.includes(item.value)}
                                    onChange={(e) => handleCheckboxChange(e, setSelectedCityzenship)} 
                                /> {item.label}
                            </span>
                        ))}
                    </Grid>
                    <Grid size={{xs:12}} container flexDirection="column" className="devider_topfiljob">
                        <button className='clear_filbtn_jobs' onClick={clearState}>Clear Filter</button>
                    </Grid>
                </div>
            </div>
        </div>
        <div className='content_container_jobboard'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Job Board</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Job Board </span>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                    <div className='knowledgetab_btnredirect'>
                        <button className={typedata === "all_jobs" ? "active_tabbtn" : ""} onClick={()=>handleShortType("all_jobs")}>All Jobs</button>
                        <button className={typedata === "my_jobs" ? "active_tabbtn" : ""} onClick={()=>handleShortType("my_jobs")}>My Jobs</button>
                    </div>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center">
                    <Grid size={{ lg:4, sm:6, xs: 12 }} container flexDirection="column">
                        <div className='d-flex jobseekersearch my-3'>
                            <div className='col-md-9 input_jobssearch'>
                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                <input type='text' placeholder='search'
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSearch(); // Trigger search on Enter key press
                                    }
                                }}/>
                            </div>
                            <div className='col-md-3 col-4'>
                                <button onClick={handleSearch}>Search</button>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={{ lg:4, sm:6, xs: 12 }} container alignItems="center" className="gap-3" justifyContent="end">
                        {permissionstest && permissionstest.manage_job_post_creator === true && <>
                            <button className='registersendbtn2 my-0' onClick={()=>navigate("/job-board/bulk-upload")}><FontAwesomeIcon icon={faArrowUpFromBracket} /> Bulk Import</button>
                            <button className='registersendbtn2 my-0' onClick={()=>navigate("/job-board/create-job")}><FontAwesomeIcon icon={faPlus} /> Create Job</button>
                            </>
                        }
                    </Grid>
                </Grid>
                {loading ? 
                <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                    <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :<>
                <Grid size={{ xs:12 }} container justifyContent="center" className="my-4">
                    <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                        <span className='total_jobs'>Total: <span>{paginatedata.total || "0"} Jobs</span></span>
                        <div className='d-flex my-2 short_byonboard'>
                            <label>Sort by: </label>
                            <select className='ms-2' onChange={(e) => handleShortNew(e.target.value)} value={shorting}>
                                <option value="newest">Newest</option>
                                <option value="oldest">Oldest</option>
                            </select>
                        </div>
                    </Grid>
                    {jobslist && jobslist.map((jobslist,index) =>(
                        <Grid size={{xs:12}} key={index} container className="main_cardjob mt-3">
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between" className="head_jobcard">
                                <Grid container className="titleadmin_joblist">
                                    {jobslist && jobslist.source === "LinkedIn" ? 
                                        <img src={require("../../assets/sample/linkedin.svg").default} alt='Job Icon'/>:
                                        jobslist.source === "Monster" ?
                                        <img src={require("../../assets/sample/monster.svg").default} alt='Job Icon'/>:
                                        jobslist.source === "Indeed" ?
                                        <img src={require("../../assets/sample/indeed.svg").default} alt='Job Icon'/>:
                                        jobslist.source === "Glassdoor" ?
                                        <img src={require("../../assets/sample/glassdoor.svg").default} alt='Job Icon'/>:
                                        jobslist.source === "Dice" ?
                                        <img src={require("../../assets/sample/dice.svg").default} alt='Job Icon'/>:
                                        jobslist.source === "Techfetch" ?
                                        <img src={require("../../assets/sample/techfetch.svg").default} alt='Job Icon'/>:
                                        jobslist.source === "TekP Intelligence" ?
                                        <img src={require("../../assets/sample/tekp.svg").default} alt='Job Icon'/>:
                                        <img src={require("../../assets/sample/others.svg").default} alt='Job Icon'/>}
                                    
                                    <div className='jobboard_listtitle'>
                                        <Link className='link_joblist' to={`/job-board/view-job/${jobslist.job_id}`}><h5 className='tittle_jobswrap'>{jobslist.title}</h5></Link>
                                        <h6 className='mb-0'>{jobslist && jobslist.location && jobslist.location !== "" && jobslist.location !== "unknown" && jobslist.location}{jobslist && jobslist.location && jobslist.location !== "" && jobslist.location !== "unknown" && jobslist.recruiter_company && jobslist.recruiter_company !== "" && jobslist.recruiter_company !== "unknown" && ' -'} {jobslist && jobslist.recruiter_company && jobslist.recruiter_company !== "" && jobslist.recruiter_company !== "unknown" && jobslist.recruiter_company }</h6>
                                    </div>
                                </Grid>
                                <Grid container flexDirection="column" className="text-center">
                                    {jobslist && jobslist.status === "active"?
                                        <small className='active_bgstatus'>Active</small>:
                                        <small className='inactive_bgstatus'>In-Active</small>
                                    }
                                    <small className='sour_typeshows'>{jobslist.source_of_job}</small>
                                </Grid>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container className="spans_icons column-gap-5 mt-4">
                                {jobslist && jobslist.site_type && jobslist.site_type !== "" && jobslist.site_type !== "unknown" &&
                                <Grid container alignItems="center">
                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/onsite.svg").default} alt='onsite'/>
                                        <span className='role_typejobicon'>
                                            <small>Site Type</small>
                                            <span>{jobslist.site_type}</span>
                                        </span>
                                    </span>
                                </Grid>}
                                {jobslist && jobslist.experience_range && jobslist.experience_range !== "" && jobslist.experience_range !== "unknown" && jobslist.experience_range !== "Unknown" &&
                                <Grid container alignItems="center">
                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/briefcase.svg").default} alt='briefcase'/>
                                        <span className='role_typejobicon'>
                                            <small>Experience</small>
                                            <span>{jobslist.experience_range}</span>
                                        </span>
                                    </span>
                                </Grid>}
                                {jobslist && jobslist.job_type && jobslist.job_type !== "" && jobslist.job_type !== "unknown" &&
                                <Grid container alignItems="center">
                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/jobtype.svg").default} alt='jobtype'/>
                                        <span className='role_typejobicon'>
                                            <small>Type</small>
                                            <span>{jobslist.job_type || "No data"}</span>
                                        </span>
                                    </span>
                                </Grid>}
                                {jobslist && jobslist.certifications && jobslist.certifications !== "" && jobslist.certifications !== "unknown" &&
                                <Grid container alignItems="center">
                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/certificate.svg").default} alt='certificate'/>
                                        <span className='role_typejobicon'>
                                            <small>Certifications</small>
                                            <span>{jobslist.certifications || "No data"}</span>
                                        </span>
                                    </span>
                                </Grid>}
                                {jobslist && (jobslist.citizenship_status !== null || jobslist.restricted_citizenship_status !== null) &&  <>
                                {jobslist && (jobslist.citizenship_status[0] !== "unknown" || jobslist.restricted_citizenship_status[0] !== "unknown") &&
                                <Grid container alignItems="center">
                                    <span className='d-flex align-items-center'><img src={require("../../assets/jobicons/visa.svg").default} alt='certificate'/>
                                        <span className='role_typejobicon'>
                                            <small>Visa</small>
                                            <div className='d-flex gap-4'>
                                                <span><FontAwesomeIcon className='iconpinkssets' icon={faCheck} />{jobslist.citizenship_status[0] === "unknown" ? "-" :<>
                                                    <span> {jobslist.citizenship_status?.map((item, index) => (
                                                        <span key={index} style={{border:"none",padding:"0px"}}>
                                                        {item}
                                                        {index !== jobslist.citizenship_status.length - 1 && ', '}
                                                        </span>
                                                    ))}</span>
                                                 </>}
                                                </span>
                                                <span><FontAwesomeIcon className='iconpinkssets' icon={faXmark} /> {jobslist.restricted_citizenship_status[0] === "unknown" ? "-" :<> 
                                                    <span> {jobslist.restricted_citizenship_status?.map((item, index) => (
                                                        <span key={index} style={{border:"none",padding:"0px"}}>
                                                        {item}
                                                        {index !== jobslist.restricted_citizenship_status.length - 1 && ', '}
                                                        </span>
                                                    ))}</span>
                                                </>}</span>
                                            </div>
                                        </span>
                                    </span>
                                </Grid>}
                                </>}
                            </Grid>
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between" className="mt-4 mb-3 endcardjobboard">
                                <small>{jobslist.created_at} <span className='job_idshowbox ms-3'>Job Id : <span>{jobslist.job_id}</span></span> <span className='job_idshowbox ms-3'>Applicants : <span>{jobslist?.job_post_application_count}</span></span><span className='job_idshowbox ms-3'>Applicants Seen : <span>{jobslist.job_post_view_count}</span></span></small>
                                <button onClick={()=> navigateToJobDetails(jobslist.job_id)} >View More</button>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
                <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage - 1)} 
                        disabled={currentPage === 1}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    {paginatedata && (
                        <div className="pagination">
                            {(() => {
                            const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                            const pages = [];
                            const start = Math.max(2, currentPage - 2);
                            const end = Math.min(totalPages - 1, currentPage + 2);

                            // Always show first page
                            pages.push(
                                <button
                                key={1}
                                onClick={() => handlePageChange(1)}
                                className={currentPage === 1 ? 'active' : ''}
                                >
                                1
                                </button>
                            );

                            if (start > 2) {
                                pages.push(<span key="start-ellipsis">...</span>);
                            }

                            for (let i = start; i <= end; i++) {
                                pages.push(
                                <button
                                    key={i}
                                    onClick={() => handlePageChange(i)}
                                    className={currentPage === i ? 'active' : ''}
                                >
                                    {i}
                                </button>
                                );
                            }

                            if (end < totalPages - 1) {
                                pages.push(<span key="end-ellipsis">...</span>);
                            }

                            if (totalPages > 1) {
                                pages.push(
                                <button
                                    key={totalPages}
                                    onClick={() => handlePageChange(totalPages)}
                                    className={currentPage === totalPages ? 'active' : ''}
                                >
                                    {totalPages}
                                </button>
                                );
                            }

                            return pages;
                            })()}
                        </div>
                        )}

                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage + 1)} 
                        disabled={currentPage === paginatedata.last_page}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </Grid>
                </>}
            </Grid>
        </div>
    </div>
  )
}

export default JobBoard
